import { render, staticRenderFns } from "./Ganadores.vue?vue&type=template&id=2467f863&scoped=true&"
import script from "./Ganadores.vue?vue&type=script&lang=js&"
export * from "./Ganadores.vue?vue&type=script&lang=js&"
import style0 from "./Ganadores.vue?vue&type=style&index=0&id=2467f863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467f863",
  null
  
)

export default component.exports